/* ── Curva Sneakers — Search IA v1 ─────────────────────────────────────────── */
(function () {
  'use strict';

  var state = {
    products: [],
    filtered: [],
    sizeFormat: 'mx',
    selectedGender: 'all',
    selectedCategory: 'all',
    selectedSize: null,
    query: '',
    loaded: false
  };

  var TENIS_TYPES = ['sneakers','cu-tenis','iv-tenis'];

  function productCategory(p) {
    var t = (p.product_type || '').toLowerCase();
    if (TENIS_TYPES.indexOf(t) !== -1) return 'tenis';
    if (t === 'gorras') return 'gorras';
    if (t === 'ropa')   return 'ropa';
    return 'otros';
  }

  var KW_ELLA = ['wmns','women','mujer','dama',' her ','girl','chica','ladies'];
  var KW_EL   = ["mens","men's",'hombre','caballero',' gs ','masculino'];
  var KW_UNI  = ['unisex','kids','junior','infantil'];
  var COL_MASC= ['negro','black','dark','gris','grey','navy','camo','café','cafe','brown','khaki','olive','militar','carbon'];
  var COL_FEM = ['rosa','pink','lila','lilac','lavender','nude','pastel','blush','coral','fucsia'];

  function classifyGender(product) {
    var t = ' ' + product.title.toLowerCase() + ' ';
    for (var i = 0; i < KW_ELLA.length; i++) if (t.indexOf(KW_ELLA[i]) !== -1) return 'ella';
    for (var i = 0; i < KW_EL.length;   i++) if (t.indexOf(KW_EL[i])   !== -1) return 'el';
    for (var i = 0; i < KW_UNI.length;  i++) if (t.indexOf(KW_UNI[i])  !== -1) return 'unisex';

    var availVariants = product.variants.filter(function(v){ return v.available; });
    var sizes = getNumericSizes(availVariants);
    if (!sizes.length) return 'unisex';

    var hasEllaZone = sizes.some(function(s){ return s <= 24.5; });
    var hasElZone   = sizes.some(function(s){ return s >= 25; });

    if (hasEllaZone && hasElZone) return 'unisex';
    if (hasElZone) return 'el';

    for (var i = 0; i < COL_MASC.length; i++) if (t.indexOf(COL_MASC[i]) !== -1) return 'unisex';
    for (var i = 0; i < COL_FEM.length;  i++) if (t.indexOf(COL_FEM[i])  !== -1) return 'unisex';
    return 'ella';
  }

  function getNumericSizes(variants) {
    var sizes = [];
    variants.forEach(function(v) {
      if (!v.option1) return;
      var opt = v.option1.replace(/\s*\(?(CU|IV)\)?$/i,'').replace(/\s*cm$/i,'').trim();
      var low = opt.toLowerCase();
      if (['única','unica','unitalla','default title'].indexOf(low) !== -1) return;
      if (opt.indexOf('/') !== -1) return;
      var n = parseFloat(opt);
      if (!isNaN(n) && n >= 18 && n <= 30) sizes.push(n);
    });
    return sizes;
  }

  function isUnitalla(product) {
    return product.variants.some(function(v) {
      var opt = (v.option1 || '').toLowerCase();
      return ['única','unica','unitalla'].indexOf(opt) !== -1;
    });
  }

  var MX_TO_EU = {22:35, 22.5:36, 23.5:37, 24:38, 24.5:39, 25.5:40, 26:41, 26.5:42, 27.5:43, 28:44, 29:45};
  var EU_TO_MX = {35:22, 36:22.5, 37:23.5, 38:24, 39:24.5, 40:25.5, 41:26, 42:26.5, 43:27.5, 44:28, 45:29};

  function mxToEu(mx) { return MX_TO_EU[mx] || Math.round((mx + 14) * 2) / 2; }
  function euToMx(eu) { return EU_TO_MX[eu] || Math.round((eu - 14) * 2) / 2; }

  function mxToTag(mx) {
    return 'talla-' + String(mx).replace('.', '-') + 'cm';
  }

  function productHasSize(product, mxSize) {
    return product.variants.some(function(v) {
      if (!v.available) return false;
      var opt = (v.option1 || '').replace(/\s*\(?(CU|IV)\)?$/i,'').replace(/\s*cm$/i,'').trim();
      var n = parseFloat(opt);
      return !isNaN(n) && Math.abs(n - mxSize) < 0.01;
    });
  }

  function getMinPrice(product) {
    var prices = product.variants.map(function(v){ return parseFloat(v.price); }).filter(function(p){ return !isNaN(p); });
    return prices.length ? Math.min.apply(null, prices) : 0;
  }

  function parseQuery(text) {
    var r = { size: null, gender: null };
    if (!text) return r;
    var t = text.toLowerCase();
    var tn = t.replace(/[áéíóúàèìòùäëïöüãñ]/g,function(c){return{'á':'a','é':'e','í':'i','ó':'o','ú':'u','à':'a','è':'e','ì':'i','ò':'o','ù':'u','ä':'a','ë':'e','ï':'i','ö':'o','ü':'u','ã':'a','ñ':'n'}[c]||c;});
    var sm = tn.match(/(?:talla\s+)?(\d{2}(?:[.,]\d)?)\s*(?:cm)?(?:\s|$)/);
    if (sm) {
      var raw = parseFloat(sm[1].replace(',','.'));
      if (raw >= 21 && raw <= 29)      r.size = raw;
      else if (raw >= 35 && raw <= 45) r.size = euToMx(raw);
    }
    if (/\b(el|caballero|hombre|chico|masculino|man|men|boy)\b/.test(tn)) r.gender = 'el';
    else if (/\b(ella|mujer|dama|chica|nina|femenino|woman|girl)\b/.test(tn)) r.gender = 'ella';
    else if (/\bunisex\b/.test(tn)) r.gender = 'unisex';
    return r;
  }

  function applyFilters() {
    var results = state.products;
    if (state.selectedCategory !== 'all') {
      results = results.filter(function(p) { return p.category === state.selectedCategory; });
    }
    var sizesWrap = document.querySelector('.cs-sp-sizes-wrap');
    var sizeHeader = document.querySelector('.cs-sp-size-header');
    var showSizes = state.selectedCategory === 'all' || state.selectedCategory === 'tenis';
    if (sizesWrap)  sizesWrap.style.display  = showSizes ? '' : 'none';
    if (sizeHeader) sizeHeader.style.display = showSizes ? '' : 'none';
    if (state.selectedGender !== 'all') {
      results = results.filter(function(p) {
        return p.gender === state.selectedGender || p.gender === 'unisex';
      });
      if (state.selectedGender !== 'unisex') {
        results.sort(function(a, b) {
          var aExact = a.gender === state.selectedGender ? 0 : 1;
          var bExact = b.gender === state.selectedGender ? 0 : 1;
          return aExact - bExact;
        });
      }
    }
    if (state.selectedSize !== null) {
      results = results.filter(function(p) { return productHasSize(p, state.selectedSize); });
    }
    if (state.query) {
      var q = state.query.toLowerCase()
        .replace(/\b\d{2}(?:[.,]\d)?\s*(?:cm)?\b/g,'')
        .replace(/\b(él|ella|el|mujer|dama|hombre|caballero|chico|chica|unisex|talla|para|con|en|de|del|la|las|los|un|una|mi|mis|su|sus|por|que|busco|quiero|necesito|hay)\b/g,'')
        .trim();
      if (q.length >= 2) {
        results = results.filter(function(p) {
          return p.title.toLowerCase().indexOf(q) !== -1 ||
                 p.product_type.toLowerCase().indexOf(q) !== -1;
        });
      }
    }
    state.filtered = results;
    renderResults();
    renderChatResponse();
    updateResultsCount();
  }

  var GENDER_LABELS = { el:'ÉL', ella:'ELLA', unisex:'UNISEX' };

  function renderResults() {
    var grid = document.getElementById('cs-results-grid');
    if (!grid) return;
    if (!state.loaded) {
      grid.innerHTML = '<div class="cs-loading"><span class="material-icons cs-spin">cached</span><p>Cargando catálogo...</p></div>';
      return;
    }
    var products = state.filtered;
    if (!products.length) {
      grid.innerHTML = '<div class="cs-no-results"><span class="material-icons">search_off</span><p>Sin modelos con esa combinación</p><button class="cs-clear-btn" onclick="CsSearch.clearFilters()">Ver todos</button></div>';
      return;
    }
    grid.innerHTML = products.map(function(p) {
      var imgSrc = p.image ? resizeImg(p.image, 400) : '';
      var imgHtml = imgSrc
        ? '<img src="' + imgSrc + '" alt="' + esc(p.title) + '" loading="lazy" class="cs-pc-img">'
        : '<span class="material-icons cs-pc-img-placeholder">directions_run</span>';
      var dot = p.gender && GENDER_LABELS[p.gender]
        ? '<span class="cs-gender-dot cs-gender-dot--' + p.gender + '">' + GENDER_LABELS[p.gender] + '</span>'
        : '';
      var sizesTxt = state.selectedSize !== null
        ? (state.sizeFormat === 'eu' ? mxToEu(state.selectedSize) : state.selectedSize) + ' ✓'
        : getSizesLabel(p);
      var price = getMinPrice(p);
      var priceStr = '$' + price.toLocaleString('es-MX', {minimumFractionDigits:0, maximumFractionDigits:0});
      return '<a href="' + p.url + '" class="cs-product-card">'
        + '<div class="cs-pc-img-wrap">' + imgHtml + dot + '</div>'
        + '<div class="cs-pc-body">'
        + '<div class="cs-pc-name">' + esc(p.title) + '</div>'
        + '<div class="cs-pc-sizes">' + sizesTxt + '</div>'
        + '<div class="cs-pc-footer"><span class="cs-pc-price">' + priceStr + '</span></div>'
        + '</div></a>';
    }).join('');
  }

  function getSizesLabel(product) {
    if (isUnitalla(product)) return 'Unitalla';
    var avail = product.variants.filter(function(v){ return v.available; });
    var sizes = getNumericSizes(avail);
    if (!sizes.length) return '';
    var unique = sizes.filter(function(v,i,a){ return a.indexOf(v) === i; }).sort(function(a,b){return a-b;});
    if (state.sizeFormat === 'eu') unique = unique.map(mxToEu);
    return unique.slice(0,6).join(' · ') + (unique.length > 6 ? '…' : '');
  }

  function renderChatResponse() {
    var wrap = document.getElementById('cs-chat-wrap');
    var txt  = document.getElementById('cs-chat-text');
    if (!wrap || !txt) return;
    var hasFilter = state.query || state.selectedGender !== 'all' || state.selectedSize !== null;
    if (!hasFilter || !state.loaded) { wrap.style.display = 'none'; return; }
    wrap.style.display = 'block';
    var n = state.filtered.length;
    var gL = { el:'para caballero', ella:'para dama', unisex:'unisex', all:'' }[state.selectedGender] || '';
    var sL = state.selectedSize ? ' en talla ' + (state.sizeFormat==='eu' ? mxToEu(state.selectedSize) : state.selectedSize) : '';
    txt.textContent = n === 0
      ? 'No encontré modelos' + sL + ' disponibles ahora. Prueba con una talla cercana.'
      : 'Encontré ' + n + ' modelo' + (n !== 1 ? 's' : '') + sL + ' ' + gL + ' disponibles.';
  }

  function updateResultsCount() {
    var el = document.getElementById('cs-results-count');
    if (!el) return;
    var n = state.filtered.length;
    var label = '';
    if (state.selectedGender !== 'all') label += (GENDER_LABELS[state.selectedGender] || '') + ' · ';
    if (state.selectedSize !== null) label += 'TALLA ' + (state.sizeFormat==='eu'?mxToEu(state.selectedSize):state.selectedSize) + ' · ';
    el.textContent = (label + n).toUpperCase();
  }

  function buildSizeChips() {
    var container = document.getElementById('cs-size-chips');
    if (!container) return;
    var sizeSet = {};
    state.products.forEach(function(p) {
      var avail = p.variants.filter(function(v){ return v.available; });
      getNumericSizes(avail).forEach(function(s){ sizeSet[s] = true; });
    });
    var sorted = Object.keys(sizeSet).map(Number).sort(function(a,b){return a-b;});
    container.innerHTML = sorted.map(function(mx) {
      var display = state.sizeFormat === 'eu' ? mxToEu(mx) : mx;
      var active  = state.selectedSize !== null && Math.abs(state.selectedSize - mx) < 0.01;
      var href = '/collections/sneakers/' + mxToTag(mx);
      return '<a href="' + href + '" class="cs-size-chip' + (active?' cs-size-chip--active':'') + '" data-mx="' + mx + '" onclick="event.preventDefault();CsSearch.selectSize(' + mx + ')">' + display + '</a>';
    }).join('');
  }

  window.CsSearch = {
    selectCategory: function(cat) {
      state.selectedCategory = state.selectedCategory === cat ? 'all' : cat;
      if (state.selectedCategory !== 'tenis' && state.selectedCategory !== 'all') {
        state.selectedSize = null;
      }
      document.querySelectorAll('.cs-cat-btn').forEach(function(b) {
        b.classList.toggle('cs-cat-btn--active', b.dataset.cat === state.selectedCategory);
      });
      buildSizeChips();
      applyFilters();
    },
    selectGender: function(gender) {
      state.selectedGender = state.selectedGender === gender ? 'all' : gender;
      document.querySelectorAll('.cs-gender-pill').forEach(function(p) {
        p.classList.toggle('cs-gender-pill--active', p.dataset.gender === state.selectedGender);
      });
      applyFilters();
    },
    selectSize: function(mx) {
      state.selectedSize = (state.selectedSize !== null && Math.abs(state.selectedSize - mx) < 0.01) ? null : mx;
      buildSizeChips();
      applyFilters();
    },
    toggleFormat: function(fmt) {
      state.sizeFormat = fmt;
      document.querySelectorAll('.cs-fmt-btn').forEach(function(b) {
        b.classList.toggle('cs-fmt-btn--active', b.dataset.fmt === fmt);
      });
      buildSizeChips();
      renderResults();
    },
    clearFilters: function() {
      state.selectedGender = 'all';
      state.selectedSize   = null;
      state.query          = '';
      var inp = document.getElementById('cs-search-input');
      if (inp) inp.value = '';
      document.querySelectorAll('.cs-gender-pill').forEach(function(p) {
        p.classList.toggle('cs-gender-pill--active', p.dataset.gender === 'all');
      });
      buildSizeChips();
      applyFilters();
    },
    onInput: function(val) {
      state.query = val;
      clearTimeout(window._csDebounce);
      window._csDebounce = setTimeout(function() {
        var parsed = parseQuery(val);
        if (!val) { CsSearch.clearFilters(); return; }
        var changed = false;
        if (parsed.size !== null && (state.selectedSize === null || Math.abs(state.selectedSize - parsed.size) > 0.01)) {
          state.selectedSize = parsed.size;
          changed = true;
        }
        if (parsed.gender && parsed.gender !== state.selectedGender) {
          state.selectedGender = parsed.gender;
          document.querySelectorAll('.cs-gender-pill').forEach(function(p) {
            p.classList.toggle('cs-gender-pill--active', p.dataset.gender === state.selectedGender);
          });
          changed = true;
        }
        if (changed) buildSizeChips();
        applyFilters();
      }, 280);
    }
  };

  function esc(s) {
    return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }
  function resizeImg(src, w) {
    if (!src) return '';
    var base = src.split('?')[0];
    base = base.replace(/_\d+x\d*(\.[a-z]+)$/i, '$1');
    return base.replace(/(\.[a-z]+)$/i, '_' + w + 'x$1');
  }

  function loadProducts() {
    var pages = [];
    function fetchPage(page) {
      return fetch('/products.json?limit=250&page=' + page)
        .then(function(r){ return r.json(); })
        .then(function(data) {
          var prods = data.products || [];
          pages = pages.concat(prods);
          if (prods.length === 250) return fetchPage(page + 1);
          return pages;
        });
    }
    return fetchPage(1);
  }

  function init() {
    loadProducts().then(function(raw) {
      state.products = raw.map(function(p) {
        return {
          id:           p.id,
          title:        p.title,
          handle:       p.handle,
          product_type: p.product_type || '',
          url:          '/products/' + p.handle,
          image:        (p.image && p.image.src) ? p.image.src
                        : (p.images && p.images.length ? p.images[0].src : ''),
          variants:     p.variants || []
        };
      }).map(function(p) {
        p.gender   = classifyGender(p);
        p.category = productCategory(p);
        return p;
      });
      state.loaded = true;
      buildSizeChips();
      applyFilters();
    }).catch(function(e) {
      console.error('CsSearch load error:', e);
      var grid = document.getElementById('cs-results-grid');
      if (grid) grid.innerHTML = '<div class="cs-no-results"><span class="material-icons">error_outline</span><p>Error cargando productos</p></div>';
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
